import "./src/styles/global.css"
import "fontsource-lato"